import { CDN_CLRSAVE_URL } from '../constants';

export const SIDEBAR_DATA = [
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/Tax-saving.svg`,
    label: 'Tax Saving',
    value: 'best-tax-saving',
  },
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/cusotmizeyourinvestment.svg`,
    label: 'Top Funds',
    value: 'explore',
  },
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/grow-wealth.svg`,
    label: 'Grow Wealth',
    value: 'grow-wealth',
  },
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/explore-funds.svg`,
    label: 'Customize your investment',
    value: 'customize-your-investment',
  },
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/1551953142_request-callback.svg`,
    label: 'Request callback',
    value: 'request-callback',
  },
];

export const SIDEBAR_DATA_MOBILE = [
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/Tax-saving.svg`,
    label: 'Top Plans',
    value: 'top-plans',
  },
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/cusotmizeyourinvestment.svg`,
    label: 'Top Funds',
    value: 'top-funds',
  },
];

export const ELSS_PLAN_POINTS = [
  'Invest in a bundle of 4 ELSS funds',
  'Plan built to offer better returns and diversify risk',
  'Invest from ₹ 2,000 onwards',
  'Suitable for first-time investors in Mutual Funds',
];

export const ELSS_SINGLE_FUND_POINTS = [
  'Invest in single ELSS Fund',
  'Selected funds with best returns over past 5 years',
  'Invest from ₹ 500 onwards',
  'Suitable for investors with basic knowledge in Mutual Funds',
];

const SECTION_BEST_TAX_SAVING = {
  title: 'Why ELSS is the Best Tax Saving (80C) Option',
  subtitle:
    'ELSS (Equity Linked Saving Scheme) is a tax-saving (80C) investment option where you can save up to Rs. 46,800 in taxes every financial year.',
  id: 'best-tax-saving',
  type: 'elss',
  splitCards: [
    {
      type: 'plan',
      title: 'Invest in our popular ELSS Plan',
      subtitle: 'This our most popular expert-recommended Tax Saver Plan',
      bucketId: '19',
      hideHighlights: true,
      hideBenifits: true,
      hideSpacer: true,
      planPoints: ELSS_PLAN_POINTS,
    },
    {
      title: 'Choose from top-performing ELSS Funds',
      subtitle:
        'If you want to choose funds on your own, these are the top Tax-Saving funds in the country based on their past returns',
      funds: 'TOP_ELSS_FUNDS',
      hideOnMobile: true,
      hideHighlights: true,
      hideBenifits: true,
      singleFundPoints: ELSS_SINGLE_FUND_POINTS,
    },
  ],
};

const SECTION_EXPLORE = {
  title: 'Top Funds by Category',
  subtitle: 'Top Performing Funds across Categories',
  id: 'explore',
  tabs: [
    {
      key: 'elss-funds',
      label: 'ELSS Funds',
      scrollId: 'explore-tabs',
      funds: 'TOP_ELSS_FUNDS',
      faqsKey: 'elss',
    },

    {
      key: 'balanced-funds',
      label: 'Balanced Funds',
      scrollId: 'explore-tabs',
      funds: 'TOP_BALANCED_FUNDS',
      faqsKey: 'balanced',
    },

    {
      key: 'equity-funds',
      label: 'Equity Funds',
      scrollId: 'explore-tabs',
      funds: 'TOP_EQUITY_FUNDS',
      faqsKey: 'equity',
    },

    {
      key: 'debt-funds',
      label: 'Debt Funds',
      scrollId: 'explore-tabs',
      funds: 'TOP_DEBT_FUNDS',
      faqsKey: 'debt',
    },

    {
      key: 'aggressive-sips',
      label: 'Aggressive SIPS',
      scrollId: 'explore-tabs',
      funds: 'TOP_AGGRESSIVE_SIPS',
      faqsKey: 'sips',
    },

    {
      key: 'smallmidcap-funds',
      label: 'Small & Midcap Funds',
      scrollId: 'explore-tabs',
      funds: 'TOP_SMALL_MIDCAP_FUNDS',
      faqsKey: 'smallMid',
    },
  ],
};

const SECTION_GROW_WEALTH = {
  title: 'Most popular Mutual Fund plans to grow your money',
  subtitle:
    'Our experts have created packages of funds for different investment needs. Choose as per your investment preferences.',
  id: 'grow-wealth',
  cards: [
    {
      type: 'plan',
      bucketId: '26',
    },
    {
      type: 'plan',
      bucketId: '22',
    },
    {
      type: 'plan',
      bucketId: '25',
    },
  ],
};

const SECTION_TIME_FRAME = {
  title: 'Top Funds by Investment Duration',
  subtitle:
    'Top Funds and Expert Curated Plans based on your Investment Time Frame',
  id: 'time-frame',
  tabs: [
    {
      label: 'Ultra Short-Term (0-1 year)',
      key: 'ultra-short-term',
      scrollId: 'customized-tabs',
      splitCards: [
        {
          type: 'plan',
          title: 'Choose from our most Popular Plan',
          subtitle:
            'This our most popular expert-recommended plan - package of 4 funds - for Ultra Short-Term investment',
          bucketId: '21',
        },
        {
          title: 'Choose from Top-performing Funds',
          subtitle:
            'If you want to choose funds on your own, these are the top-performing funds for Ultra Short-Term investment',
          funds: 'TOP_LIQUID_FUNDS',
        },
      ],
    },
    {
      label: 'Short-Term (1-3 years)',
      key: 'short-term',
      scrollId: 'customized-tabs',
      splitCards: [
        {
          type: 'plan',
          title: 'Choose from our most Popular Plan',
          subtitle:
            'This our most popular expert-recommended plan - package of 4 funds - for Short-Term investment',
          bucketId: '20',
        },
        {
          title: 'Choose from Top-performing Funds',
          subtitle:
            'If you want to choose funds on your own, these are the top-performing funds for Short-Term investment',
          funds: 'TOP_DEBT_FUNDS',
        },
      ],
    },
    {
      label: 'Medium-Term (3-5 years)',
      key: 'medium-term',
      scrollId: 'customized-tabs',
      splitCards: [
        {
          type: 'plan',
          title: 'Choose from our most Popular Plan',
          subtitle:
            'This our most popular expert-recommended plan - package of 4 funds - for Medium-Term investment',
          bucketId: '25',
        },
        {
          title: 'Choose from Top-performing Funds',
          subtitle:
            'If you want to choose funds on your own, these are the top-performing funds for Medium-Term investment',
          funds: 'TOP_BALANCED_LARGECAP',
        },
      ],
    },
    {
      label: 'Long-Term (5 years or more)',
      key: 'long-term',
      scrollId: 'customized-tabs',
      splitCards: [
        {
          type: 'plan',
          title: 'Choose from our most Popular Plan',
          subtitle:
            'This our most popular expert-recommended plan - package of 4 funds - for Long-Term investment',
          bucketId: '22',
        },
        {
          title: 'Choose from Top-performing Funds',
          subtitle:
            'If you want to choose funds on your own, these are the top-performing funds for Long-Term investment',
          funds: 'TOP_EQUITY_FUNDS',
        },
      ],
    },
  ],
};

/*const SECTION_RISK_RETURN = [
  {
    title: 'Choose by risk-return preference',
    subtitle:
      'Based on how you want to balance risk and return in your investments, here are plans and funds recommended by our experts',
    id: 'risk-return',
    tabs: [
      {
        label: 'Moderate Return-Risk',
        key: 'moderate-risk',
        scrollId: 'risk-customized-tabs',
        splitCards: [
          {
            type: 'plan',
            title: 'Choose from our most Popular Plan',
            subtitle:
              'This our most popular expert-recommended plan - package of 4 funds - if you have a Moderate Risk-Return preference',
            bucketId: '25',
          },
          {
            title: 'Choose from Top-performing Funds',
            subtitle:
              'If you want to choose funds on your own, these are the top-performing funds with Moderate Risk-Return profile',
            funds: 'TOP_BALANCED_LARGECAP',
          },
        ],
      },

      {
        label: 'High Return-Risk',
        key: 'high-risk',
        scrollId: 'risk-customized-tabs',
        splitCards: [
          {
            type: 'plan',
            title: 'Choose from our most Popular Plan',
            subtitle:
              'This our most popular expert-recommended plan - package of 4 funds - if you have a High Risk-Return preference',
            bucketId: '26',
          },
          {
            title: 'Choose from Top-performing Funds',
            subtitle:
              'If you want to choose funds on your own, these are the top-performing funds with High Risk-Return profile',
            funds: 'TOP_SMALL_MIDCAP_SECTORIAL_FUNDS',
          },
        ],
      },

      {
        label: 'Low Return-Risk',
        key: 'low-risk',
        scrollId: 'risk-customized-tabs',
        splitCards: [
          {
            type: 'plan',
            title: 'Choose from our most Popular Plan',
            subtitle:
              'This our most popular expert-recommended plan - package of 4 funds - if you have a Low Risk-Return preference',
            bucketId: '20',
          },
          {
            title: 'Choose from Top-performing Funds',
            subtitle:
              'If you want to choose funds on your own, these are the top-performing funds with Low Risk-Return profile',
            funds: 'TOP_DEBT_FUNDS',
          },
        ],
      },
    ],
  },
];*/

export const SECTIONS = [
  ...[SECTION_BEST_TAX_SAVING],
  ...[SECTION_EXPLORE],
  ...[SECTION_GROW_WEALTH],

  {
    type: 'multiple',
    id: 'customize-your-investment',
    sections: [...[SECTION_TIME_FRAME]],
  },
];

export const PAGE_TITLE = 'Mutual Funds Investment Made Simple';

export const SLIDE_DATA = [
  {
    title: 'Increase your Tax Savings',
    subtitle: 'Choose from our curated popular plans or top Tax Saver funds.',
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave/images/new_lt.svg`,
  },

  {
    title: 'Grow your wealth',
    subtitle:
      'Choose from our expert-recommended plans or top Equity funds as per your investment preferences.',
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave/images/new_lt.svg`,
  },

  {
    title: 'Discover top-performing funds',
    subtitle: 'Choose from over 60 top Equity funds across categories.',
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave/images/new_lt.svg`,
  },
];

const MOBILE_NAV_DATA_COMMON = [
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/explore-funds.svg`,
    label: 'Explore',
    link: '/save/search',
  },

  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/cusotmizeyourinvestment.svg`,
    label: 'My Account',
    link: '/save/dashboard/portfolio',
  },
];

export const MOBILE_NAV_DATA = [
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/Tax-saving.svg`,
    label: 'Top Plans',
    value: 'top-plans',
  },
  {
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/grow-wealth.svg`,
    label: 'Top Funds',
    value: 'top-funds',
  },

  ...MOBILE_NAV_DATA_COMMON,
];

export const MOBILE_SIDE_NAV_LOGGED_IN = [
  {
    icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/my-account1.svg`,
    link: '/save/dashboard/portfolio',
    label: 'My Account',
  },
];

export const MOBILE_SIDE_NAV_COMMON = [
  {
    icon: `${CDN_CLRSAVE_URL}/clearsave-frontend/images/help-icon.svg`,
    link: '/save/help',
    label: 'Help',
  },
];

export const SAVE_TAXES_PLAN_POINTS = [
  'Choose from the best performing ELSS funds',
  'Earn better returns compared to other 80C',
  'Instantly download your 80C investment proof',
  'Invest in just 5 minutes',
];

export const PRO_POINTS = [
  {
    icon: 'images/people.svg',
    text: '100% Paperless Process',
  },
  {
    icon: 'images/cards2.svg',
    text: '24x7 Customer Support',
  },
  {
    icon: 'images/paper.svg',
    text: '100% Free, Easy & Safe',
  },
];

export const ELSS_GRAPH_LEGEND = [
  {
    legend: 'ELSS',
    color: '#34BF49',
  },
  {
    legend: 'PPF',
    color: '#FF7183',
  },
  {
    legend: 'FD',
    color: '#FFBA50',
  },
];

export const GRAPH_POINTS = [
  {
    point: 'Better returns than PPF & FD*',
    icon: 'better-graph.svg',
  },

  {
    point: 'Lowest lock-in period of 3 years',
    icon: 'star.svg',
  },
  {
    point: 'Option to invest in monthly SIP',
    icon: '1549374187_option-monthly-sip.png',
  },
];



// WEBPACK FOOTER //
// ./constants/homeConstants.ts